export default __webpack_public_path__ + "72520c4227c7c4f8a847b4d6672dca6e.svg";